<template>
  <v-container>
    <div class="footer-border" />
    <h4 class="header">
      VIEWING AS
    </h4>
    <p
      class="data"
      data-cy="viewing-as-user-name"
    >
      <b>{{ userName }}</b>{{ roleType }}
    </p>
    <p
      v-if="companyName"
      data-cy="viewing-as-company-name"
      class="data"
    >
      {{ companyName }}
    </p>
    <p
      v-if="viewAsCompany != null || !snAdmin"
      class="data"
    >
      {{ orgId }} {{ isStaging ? 'Staging' : 'Production' }}
    </p>
  </v-container>
</template>

<script>

import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  name: 'ViewingAs',
  props: {
    userName: {
      type: String,
      default: '',
      required: false
    }
  },
  computed: {
    ...mapGetters(['user', 'isStaging', 'mersOrgId', 'viewAsCompany']),
    roleType () {
      if (this.user.accountType) {
        const roleDisplay = _.capitalize(this.user.accountType.replaceAll('_', ' ')).replace('Evault', 'eVault')
        return ` - ${roleDisplay}`
      }
      return ''
    },
    snAdmin () {
      return this.user != null && this.user.isSnAdmin
    },
    orgId () {
      if (this.mersOrgId == null || this.mersOrgId === 'undefined') {
        return ''
      }
      return this.mersOrgId + ' - '
    },
    companyName () {
      if (!this.user) {
        return null
      } else if (this.user.isSnAdmin && this.viewAsCompany) {
        return this.viewAsCompany.name
      } else if (this.user.company) {
        return this.user.company.name
      }
      return null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui';
.container {
  padding: 16px;
}

.footer-border {
  margin: -16px -16px 16px -16px;
  border-top: 1px solid #E5E5E5 !important;
}

.header {
  color: #BFBFBF;
}

.data {
  margin: 0 !important;
}

</style>
